import { render, staticRenderFns } from "./OnboardingWizard2Page.vue?vue&type=template&id=2a5d6d7f&scoped=true&"
import script from "./OnboardingWizard2Page.vue?vue&type=script&lang=js&"
export * from "./OnboardingWizard2Page.vue?vue&type=script&lang=js&"
import style0 from "./OnboardingWizard2Page.vue?vue&type=style&index=0&id=2a5d6d7f&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a5d6d7f",
  null
  
)

export default component.exports